import { Component } from "@angular/core";
import { RouterOutlet } from "@angular/router";

import { HttpProgressComponent } from "@features/+shared/http-progress/http-progress.component";
import { ToastHostComponent } from "@features/+shared/notifications/toast-host/toast-host.component";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  imports: [RouterOutlet, ToastHostComponent, HttpProgressComponent],
})
export class AppComponent {
  token: string | null = null;
}
